import React from "react";

export default ({ children, showDiv = true, ...props }) => {
	return showDiv ? <div>{children}</div> : children;
};
